import gql from 'graphql-tag';

export const createCommercialContact = gql`
  mutation createCommercialContact($input: CommercialContactInput!) {
    createCommercialContact(input: $input) {
      id
      firstName
      lastName
      companyId
      jobRoleId
      deskPhone
      mobilePhone
      emailAddress
      ice
      createdAt
      createdBy
      updatedAt
      updater
      version
      Company {
        id
        name
      }
      JobRole {
        id
        name
      }
    }
  }
`;
